module.exports = __webpack_public_path__ + "media/images/choose/browse_lessons_student-f48f1d553175ed7d624a1778f1f5fb22.png";